import { Injectable } from '@angular/core';

export interface LegacyConnectionDetails {
    host: string;
    port?: string | null;
    database?: string;
    user: string;
    password: string;
    error: string | null;
}

@Injectable({
    providedIn: 'root'
})
export class ConnectionStringService {
    public createSqlString(host: string, port: number, user: string, password: string, database: string): string {
        let result = `Server=${host};Database=${database};`;

        if (port) {
            result += `Port=${port};`;
        }

        result += `User Id=${user};Password=${password};`;

        return result;
    }

    public createOracleString(host: string, port: number, user: string, password: string): string {
        const dataSource = port ? `Data Source=${host}:${port};` : `Data Source=${host};`;

        return dataSource + `User Id=${user};Password=${password};Integrated Security=no`;
    }

    public createSftpString(host: string, port: number, user: string, password: string): string {
        let result = `sftp://${user}:${password}@${host}`;

        if (port) {
            result += `:${port}`;
        }

        return result;
    }

    public createFsString(host: string, user: string, password: string): string {
        const result = `fs://${user}:${password}@${host}`;
        return result;
    }

    public parseSqlString(value: string): LegacyConnectionDetails | null {
        const regExpWithPort =
            /Server=(?<host>.+);Database=(?<database>.+);Port=(?<port>\d+);User Id=(?<user>.+);Password=(?<pass>.+)/;
        let matches = value.match(regExpWithPort);
        if (matches?.groups) {
            return {
                host: matches.groups['host'],
                database: matches.groups['database'],
                port: matches.groups['port'],
                user: matches.groups['user'],
                password: matches.groups['pass'],
                error: ''
            };
        }

        const regExpWithoutPort =
            /Server=(?<host>.+);Database=(?<database>.+);User Id=(?<user>.+);Password=(?<pass>.+)/;
        matches = value.match(regExpWithoutPort);
        if (matches?.groups) {
            return {
                host: matches.groups['host'],
                database: matches.groups['database'],
                user: matches.groups['user'],
                password: matches.groups['pass'],
                error: ''
            };
        }

        return null;
    }

    public parseOracleString(value: string): LegacyConnectionDetails | null {
        const regExpWithPort =
            /Data Source=(?<host>.+):(?<port>\d+);User Id=(?<user>.+);Password=(?<pass>.+);Integrated Security=no/;
        let matches = value.match(regExpWithPort);
        if (matches?.groups) {
            return {
                host: matches.groups['host'],
                port: matches.groups['port'],
                user: matches.groups['user'],
                password: matches.groups['pass'],
                error: ''
            };
        }

        const regExpWithoutPort =
            /Data Source=(?<host>.+);User Id=(?<user>.+);Password=(?<pass>.+);Integrated Security=no/;
        matches = value.match(regExpWithoutPort);
        if (matches?.groups) {
            return {
                host: matches.groups['host'],
                user: matches.groups['user'],
                password: matches.groups['pass'],
                error: ''
            };
        }

        return null;
    }

    public parseSftpString(value: string): LegacyConnectionDetails | null {
        const regExpWithPort = /sftp:\/\/(?<user>.+):(?<pass>.+)@(?<host>.+):(?<port>\d+)/;
        let matches = value.match(regExpWithPort);
        if (matches?.groups) {
            return {
                host: matches.groups['host'],
                port: matches.groups['port'],
                user: matches.groups['user'],
                password: matches.groups['pass'],
                error: ''
            };
        }

        const regExpWithoutPort = /sftp:\/\/(?<user>.+):(?<pass>.+)@(?<host>.+)/;
        matches = value.match(regExpWithoutPort);
        if (matches?.groups) {
            return {
                host: matches.groups['host'],
                user: matches.groups['user'],
                password: matches.groups['pass'],
                error: ''
            };
        }

        return null;
    }

    public parseFsString(value: string): LegacyConnectionDetails | null {
        const regExpWithoutPort = /fs:\/\/(?<user>.+):(?<pass>.+)@(?<host>.+)/;
        const matches = value.match(regExpWithoutPort);
        if (matches?.groups) {
            return {
                host: matches.groups['host'],
                user: matches.groups['user'],
                password: matches.groups['pass'],
                error: ''
            };
        }

        return null;
    }
}
